import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DialogService } from '@core/services/dialog';
import { catchError, of, throwError } from 'rxjs';

const validationErrorCodes = [400];
const exceptionCodes = [500, 401, 403];

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    private dialogService = inject(DialogService);

    public intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req).pipe(
            catchError((error: any) => {
                if (error instanceof HttpErrorResponse) {
                    if (validationErrorCodes.includes(error.status) || exceptionCodes.includes(error.status)) {
                        this.dialogService
                            .openErrorDialog({
                                activityId: error.error?.ActivityId ?? error?.error?.traceId,
                                statusCode: error.status,
                            })
                            .catch(err => console.error(err));
                    }

                    return throwError(() => error);
                }

                return of(error);
            })
        );
    }
}
